import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container order"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "pagination"
};
import { onMounted, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage, ElMessageBox } from "element-plus";
import { dateFormat, removeArrayItem } from "@/utils/libs";
import { Delete, Search } from "@element-plus/icons-vue";

// 变量定义

export default {
  __name: 'Order',
  setup(__props) {
    const items = ref([]);
    const query = ref({
      order_no: "",
      pay_time: [],
      status: -1
    });
    const total = ref(0);
    const page = ref(1);
    const pageSize = ref(15);
    const loading = ref(true);
    const orderStatus = ref([{
      value: -1,
      label: "全部"
    }, {
      value: 0,
      label: "未支付"
    }, {
      value: 2,
      label: "已支付"
    }]);
    onMounted(() => {
      fetchData();
    });
    // 获取数据
    const fetchData = () => {
      query.value.page = page.value;
      query.value.page_size = pageSize.value;
      httpPost("/admin/order/list", query.value).then(res => {
        if (res.data) {
          items.value = res.data.items;
          total.value = res.data.total;
          page.value = res.data.page;
          pageSize.value = res.data.page_size;
        }
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const remove = function (row) {
      httpGet("/admin/order/remove?id=" + row.id).then(() => {
        ElMessage.success("删除成功！");
        items.value = removeArrayItem(items.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    const clearOrders = () => {
      ElMessageBox.confirm("此操作将会删除所有未支付订单，继续操作吗?", "删除提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/admin/order/clear").then(() => {
          ElMessage.success("订单删除成功");
          page.value = 0;
          fetchData();
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        modelValue: query.value.order_no,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value.order_no = $event),
        placeholder: "订单号",
        class: "handle-input mr10"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: query.value.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => query.value.status = $event),
        placeholder: "订单状态",
        style: {
          "width": "100px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderStatus.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
        modelValue: query.value.pay_time,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => query.value.pay_time = $event),
        type: "daterange",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        style: {
          "margin": "0 10px",
          "width": "200px",
          "position": "relative",
          "top": "3px"
        }
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Search),
        onClick: fetchData
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "danger",
        icon: _unref(Delete),
        onClick: clearOrders
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("清空未支付订单")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "order_no",
            label: "订单号"
          }), _createVNode(_component_el_table_column, {
            prop: "trade_no",
            label: "交易号"
          }), _createVNode(_component_el_table_column, {
            prop: "username",
            label: "下单用户"
          }), _createVNode(_component_el_table_column, {
            prop: "subject",
            label: "产品名称"
          }), _createVNode(_component_el_table_column, {
            prop: "amount",
            label: "订单金额"
          }), _createVNode(_component_el_table_column, {
            label: "充值算力"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.remark?.power), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "下单时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "支付时间"
          }, {
            default: _withCtx(scope => [scope.row['pay_time'] ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(dateFormat)(scope.row["pay_time"])), 1)) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("未支付")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "pay_method",
            label: "支付渠道"
          }), _createVNode(_component_el_table_column, {
            prop: "pay_name",
            label: "支付名称"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row)
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [total.value > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        layout: "total,prev, pager, next",
        "hide-on-single-page": true,
        "current-page": page.value,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => page.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[4] || (_cache[4] = $event => pageSize.value = $event),
        onCurrentChange: _cache[5] || (_cache[5] = $event => fetchData()),
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])])), [[_directive_loading, loading.value]]);
    };
  }
};